import ApiService from "../api";

export default class GrupoContabilService extends ApiService {

    constructor() {
        super("/api/grupo-contabil");
    }

    listar() {
        return this.get("");
    }

    buscarPorCodigo(codigo) {
        return this.get(`/${codigo}`);
    }

    salvar(dto) {
        return this.post("", dto);
    }

    atualizar(codigo, dto) {
        return this.put(`/${codigo}`, dto);
    }

    excluir(codigo) {
        return this.delete(`/${codigo}`);
    }
}
